import mask from 'slim-mask-js'

export default function phoneNumberMask(str = '') {
  if (str.length <= 10) return mask(str, '(##) ####-####')
  return mask(str, '(##) # ####-####')
}
